import {
  CostChangeValue,
  isMissingValue,
  VariantPackCostChange,
} from '@sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';
import { EMPTY_VALUE_LABEL } from '@sales-portal/constants';

/**
 * The review and bookmarked tables render rows the cost-change pipeline has
 * incomplete data for, so a numeric column must show `--` wherever the row
 * carries a placeholder 0 rather than a real value.
 */
export const formatOrEmpty = (
  row: Pick<VariantPackCostChange, 'missingValues'>,
  values: CostChangeValue[],
  format: () => string,
): string =>
  values.some((value) => isMissingValue(row, value))
    ? EMPTY_VALUE_LABEL
    : format();

export const isEmptyDisplayValue = (value: string): boolean =>
  value === EMPTY_VALUE_LABEL;

/**
 * The range-filter twin of `formatOrEmpty`: null keeps a `--` row out of the
 * column's bounds and out of its filtering, instead of ranging it as a 0.
 */
export const valueOrNull = (
  row: Pick<VariantPackCostChange, 'missingValues'>,
  values: CostChangeValue[],
  compute: () => number | null,
): number | null =>
  values.some((value) => isMissingValue(row, value)) ? null : compute();

/** Delta cells drop their arrow when there is no number behind them. */
export const emptyDelta = {
  direction: undefined,
  formattedValue: EMPTY_VALUE_LABEL,
};
